import { SplitTest } from 'Shared/services/opa/api/opaApi';
import { OPA_VARIABLE } from 'Shared/services/opa/constants';

export interface PromoBannerSplitTest extends SplitTest {
  variables: {
    [OPA_VARIABLE.SPA_SJGROW_3366_ENABLED]: boolean | null,
  }
}

/**
 * Returns the split test configuration for promo banner.
 * SJGROW-3366 is disabled: always returns the control (original banner)
 * without calling OPA. Revert this function to re-enable the experiment.
 */
export const promoBannerSplitTest = (): PromoBannerSplitTest => ({
  enabled: false,
  variables: {
    [OPA_VARIABLE.SPA_SJGROW_3366_ENABLED]: false,
  },
});

